import ConjunctionSelect from '@/components/core/select/ConjunctionSelect';
import { useConjunctionTable } from '@/components/astroOne/conjunctionTable/body/conjunctionTableHooks';
import { SearchType } from '@/components/astroOne/conjunctionTable/header/Search';
import ConjunctionCardList from '@/components/conjunction/ConjunctionCardList';
import { CONJUNCTION_TABLE_CONTEXT } from '@/constants/context';
import Pagination from '@/components/ui/table/Pagination';

const MOBILE_LIMIT = 5;
const MOBILE_PAGE = 20;

const ConjunctionCalendarMobile = () => {
  const {
    selected,
    setSelected,
    page,
    setPage,
    isLoading,
    isFetching,
    tableData,
    startCollection,
    endCollection,
  } = useConjunctionTable({ limit: MOBILE_LIMIT, queryKey: SearchType.SEARCH });

  return (
    <div className='max-w-[360px] mx-auto py-10 w-full flex flex-col gap-10 pb-20'>
      <div className='flex flex-col gap-8 px-4'>
        {/* Title and Select */}
        <div className='flex flex-col gap-2'>
          <div className='flex items-start gap-2'>
            <div className='flex flex-col'>
              <div className='flex flex-col gap-1'>
                <h3
                  style={{ fontSize: '18px' }}
                  className='font-semibold text-black m-0'
                >
                  {CONJUNCTION_TABLE_CONTEXT.TITLE}
                </h3>
                <div
                  style={{ fontSize: '12px' }}
                  className='font-medium text-[#6C6C6C] m-0'
                >
                  {CONJUNCTION_TABLE_CONTEXT.DESCRIPTION}
                </div>
                <div>
                  <p
                    style={{ fontSize: '12px' }}
                    className='font-medium text-[#6C6C6C] m-0'
                  >
                    Prediction Window :
                  </p>
                  <p
                    style={{ fontSize: '12px' }}
                    className='font-medium text-[#6C6C6C] m-0'
                  >
                    {startCollection} ~ {endCollection} (UTC)
                  </p>
                </div>
              </div>
            </div>
          </div>
          <ConjunctionSelect
            selected={selected}
            setSelected={setSelected}
            type='CALENDAR'
          />
          <div className='w-full flex flex-col gap-1 border border-[#FCCB164D] rounded-lg p-1 bg-black'>
            {/* Card List */}
            <ConjunctionCardList
              data={tableData}
              page={page}
              limit={MOBILE_LIMIT}
              isLoading={isLoading || isFetching}
            />

            {/* Pagination */}
            <Pagination
              page={page}
              setPage={setPage}
              totalPages={MOBILE_PAGE}
              isMobile={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConjunctionCalendarMobile;
